import Index from '@tunnel-components/@pages/supervision/inhibitions/home/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/inhibitions/home/index.ts